import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["reducePadding", "title", "color", "children"];
import { Disclosure, Transition } from "@headlessui/react";
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Accordion = _ref => {
  var {
    reducePadding,
    title,
    color,
    children: _children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useAccordionClass({
    color
  });
  return /*#__PURE__*/_jsx(Disclosure, _extends({}, rest, {
    as: "div",
    className: classes,
    children: _ref2 => {
      var {
        open
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Disclosure.Button, {
          className: "accordion-button",
          children: [title, /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: "transform duration-300 ease-in-out " + (!open ? "rotate-180" : ""),
            fill: "none",
            viewBox: "0 0 20 20",
            stroke: "currentColor",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M19 9l-7 7-7-7"
            })
          })]
        }), /*#__PURE__*/_jsx(Transition, {
          enter: "transition duration-300 ease-out",
          enterFrom: "transform opacity-0",
          enterTo: "transform opacity-100",
          leave: "transition duration-150 ease-out",
          leaveFrom: "transform opacity-100",
          leaveTo: "transform opacity-0",
          children: /*#__PURE__*/_jsx(Disclosure.Panel, {
            className: "accordion-panel " + (reducePadding ? "!pt-0 !pl-4 !pr-4" : ""),
            children: _children
          })
        })]
      });
    }
  }));
};
var useAccordionClass = createMemoClass(props => {
  var colors = {
    primary: "accordion-primary",
    secondary: "accordion-secondary",
    tertiary: "accordion-tertiary",
    neutral: "accordion-neutral",
    transparent: "accordion-transparent"
  };
  var classes = clsx("accordion", colors[props.color]);
  return classes;
});
//# sourceMappingURL=accordion.js.map